export const testimonials = [
  {
    description: "home.page.testimonials.section.user.one.description",
    name: "home.page.testimonials.section.user.one.name",
    title: "home.page.testimonials.section.user.one.title",
    image: new URL(`../assets/testUserOne.png`, import.meta.url).href,
  },
  {
    description: "home.page.testimonials.section.user.two.description",
    name: "home.page.testimonials.section.user.two.name",
    title: "home.page.testimonials.section.user.two.title",
    image: new URL(`../assets/testUserTwo.png`, import.meta.url).href,
  },
  {
    description: "home.page.testimonials.section.user.three.description",
    name: "home.page.testimonials.section.user.three.name",
    title: "home.page.testimonials.section.user.three.title",
    image: new URL(`../assets/testUserThree.png`, import.meta.url).href,
  },
];
